webpackJsonp([220257848752156],{

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0032_potent_basilisk.jpg","type":"Unit","subtype":"Beast","cost":4,"ATK":3,"HP":5,"rules_text_1":"Arrives: You may destroy an upgrade or ongoing spell.","rules_text_2":"Untargetable, deathtouch","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Potent Basilisk","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Their gaze is deadly and their scales reflective.","color":"Green","spec":"Balance","bottom":"Tech II","rulings":[],"keywords":["Deathtouch","Untargetable"],"slug":"potent_basilisk"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"potent_basilisk","keywords":["Deathtouch","Untargetable"],"imageRegex":"/potent_basilisk.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-potent-basilisk-53c7e17f0ca2518de16d.js